import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Button, Text } from '@chakra-ui/react';
import Navbar from './Navbar';
import UserMLResp from './MLInfo';
import AuthContext from '../context/AuthContext';
import Loading from './Loading';
import { API_BASE_URL } from '../config/adminConfig';

function MLStats() {
  const { token } = useContext(AuthContext);
  const [analyticsSummary, setAnalyticsSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAnalyticsSummary = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(
        `${API_BASE_URL}/api/admin/aiAnalyticsSummary`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setAnalyticsSummary(response.data);
    } catch (requestError) {
      setError(
        requestError?.response?.data?.message ||
          'Unable to load AI analytics summary.',
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalyticsSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box minH="100vh" bg="gray.50">
      <Navbar />
      {error ? (
        <Box maxW="5xl" mx="auto" px={6} py={12}>
          <Box
            bg="white"
            borderRadius="2xl"
            boxShadow="sm"
            p={8}
            border="1px solid"
            borderColor="red.100"
          >
            <Text fontSize="2xl" fontWeight="700" mb={3}>
              AI analytics unavailable
            </Text>
            <Text color="gray.600" mb={6}>
              {error}
            </Text>
            <Button colorScheme="blue" onClick={fetchAnalyticsSummary}>
              Retry
            </Button>
          </Box>
        </Box>
      ) : (
        <UserMLResp summaryData={analyticsSummary} onRefresh={fetchAnalyticsSummary} />
      )}
    </Box>
  );
}

export default MLStats;
